import { Radio as MuiRadio, FormControlLabel } from '@mui/material';
import type {
  RadioProps as MuiRadioProps,
  FormControlLabelProps as MuiFormControlLabelProps,
} from '@mui/material';

export type RadioProps = MuiRadioProps & {
  value: MuiFormControlLabelProps['value'];
  label: MuiFormControlLabelProps['label'];
  formControlLabelProps?: Omit<MuiFormControlLabelProps, 'value' | 'label'>;
};

/**
 * Radio component, part of Delogue design system.
 * @param value - the value of the radio button, used to identify which radio is selected in a RadioGroup
 * @param label - label to display next to the radio button
 * @param formControlLabelProps - additional props to pass to the FormControlLabel component
 * @param onChange - callback function to be called when the radio value changes
 * @param onBlur - callback function to be called when the radio loses focus
 * @param checked - whether the radio is checked
 * @param defaultChecked - whether the radio is checked by default
 * @param disabled - whether the radio is disabled
 */
export const Radio = ({
  formControlLabelProps,
  onChange,
  onBlur,
  value,
  label,
  ...props
}: RadioProps) => {
  return (
    <FormControlLabel
      {...formControlLabelProps}
      control={
        <MuiRadio
          color="primary"
          {...props}
          onChange={(event, checked) => {
            onChange?.(event, checked);
          }}
          onBlur={e => {
            onBlur?.(e);
          }}
        />
      }
      value={value}
      label={label}
    />
  );
};
